import React from 'react'
import "../scss/general.scss";
import "../scss/home.scss";
import "../scss/onogram.scss";
import { useStyles } from "./styles";
import { OrganogramBanner, OrganoGram } from "../../../assets/images/images";
import { Container, Box, Grid, } from '@material-ui/core';

function OrganoGaram() {
    const classes = useStyles();

    return (
        <div>
            <section className="sub-page-overlay-banner" style={{ backgroundImage: `url("${OrganogramBanner}")` }}>
                <span className="sub-page-overlay-effect"></span>
                <Container fixed>
                    <Box className="sub-page-overlay-banner-outer" display="flex" justifyContent="center" textAlign="center" flexDirection="column">
                        <h2 className="heading-border">
                            ORGANOGARAM<span></span>
                        </h2>
                        <span className="subpage-overlay-banner-span">Wapda / Organogram</span>
                    </Box>
                </Container>
            </section>
            <section>
                    <img className='img-responsive img-full' src={OrganoGram} />
            </section>
        </div>
        //     <Container fixed >
        //         <section style={{ marginTop: '30px', marginBottom: '30px' }}>
        //             <div class="container">

        //                 <h1 class='level-1 rectangle' >Chairman <span class='icon-chairman' style={{ backgroundImage: `url("${onoSvg}")`, backgroundRepeat: 'no-repeat' }}>
        //                 </span>
        //                     <span className='icon-dot-chairman'></span>
        //                 </h1>
        //                 <ol class="level-2-wrapper ">
        //                     <li>
        //                         <h2 class="level-2 rectangle level-2-right positionRelative ">
        //                             <span class="icon-dot-left icon-dot-right"></span>PSO to Chairman
        //                         </h2 >
        //                         <h2 class="level-2 last-child level-2-left rectangle positionRelative"><span class=" icon-dot-right"></span>GM (M&S)</h2>
        //                         <ol class="level-3-wrapper level-3-wrapper-off">
        //                             <li>
        //                                 <h3 class="level-3 rectangle">MD Admin</h3>
        //                                 <ol class="level-4-wrapper">
        //                                     {/* <li>
        //                                         <h4 class="level-4 rectangle">Person A</h4>
        //                                     </li>
        //                                     <li>
        //                                         <h4 class="level-4 rectangle">Person B</h4>
        //                                     </li>
        //                                     <li>
        //                                         <h4 class="level-4 rectangle">Person C</h4>
        //                                     </li>
        //                                     <li>
        //                                         <h4 class="level-4 rectangle">Person D</h4>
        //                                     </li> */}
        //                                 </ol>
        //                             </li>
        //                             <li>
        //                                 <h3 class="level-3 rectangle">Member Finance</h3>
        //                                 <ol class="level-4-wrapper">
        //                                     <li>
        //                                         <h4 class="level-4 rectangle">Gm Finance Coord</h4>
        //                                     </li>
        //                                     <li>
        //                                         <h4 class="level-4 rectangle">Cheif Auditor</h4>
        //                                     </li>
        //                                 </ol>
        //                             </li>
        //                         </ol>
        //                     </li>
        //                     <li>
        //                         <h2 class="level-2 rectangle level-2-left positionRelative level-2-rr"><span class=" icon-dot-left"></span>Secretary WAPDA</h2>
        //                         <h2 class="level-2 rectangle level-2-left last-child positionRelative level-2-rr"><span class=" icon-dot-left"></span>GM (LA&R/HRD)</h2>
        //                         <ol class="level-3-wrapper">
        //                             <li>
        //                                 <h3 class="level-3 rectangle">Member Water</h3>
        //                                 <ol class="level-4-wrapper">
        //                                     <li>
        //                                         <h4 class="level-4 rectangle">GM (C&M)Water</h4>
        //                                     </li>
        //                                     <li>
        //                                         <h4 class="level-4 rectangle">GM (Tarbela Dam)</h4>
        //                                     </li>
        //                                     <li>
        //                                         <h4 class="level-4 rectangle">GM (Projects) North</h4>
        //                                     </li>
        //                                     <li>
        //                                         <h4 class="level-4 rectangle">GM (Projects) South</h4>
        //                                     </li>
        //                                     <li>
        //                                         <h4 class="level-4 rectangle">GM (Projects) NA</h4>
        //                                     </li>
        //                                     <li>
        //                                         <h4 class="level-4 rectangle">GM (Central) Water</h4>
        //                                     </li>
        //                                     <li>
        //                                         <h4 class="level-4 rectangle">GM (Dasu) HPP </h4>
        //                                     </li>
        //                                     <li>
        //                                         <h4 class="level-4 rectangle">GM (MDO)</h4>
        //                                     </li>
        //                                 </ol>
        //                             </li>
        //                             <li>
        //                                 <h3 class="level-3 rectangle">Member Power</h3>
        //                                 <ol class="level-4-wrapper">
        //                                     <li>
        //                                         <h4 class="level-4 rectangle">GM (Coord) Power</h4>
        //                                     </li>
        //                                     <li>
        //                                         <h4 class="level-4 rectangle">GM (Hydel) Oper</h4>
        //                                     </li>
        //                                     <li>
        //                                         <h4 class="level-4 rectangle">GM (Hydel) Dev</h4>
        //                                     </li>
        //                                     <li>
        //                                         <h4 class="level-4 rectangle">GM (Finance) Power</h4>
        //                                     </li>
        //                                     <li>
        //                                         <h4 class="level-4 rectangle">GM (Training)</h4>
        //                                     </li>
        //                                 </ol>
        //                             </li>
        //                         </ol>
        //                     </li>
        //                 </ol>
        //             </div>
        //         </section>
        //     </Container>
        // </div >
    )
}

export default OrganoGaram